import{commonjsGlobal as o}from"../../_virtual/_commonjsHelpers.js";var e="object"==typeof o&&o&&o.Object===Object&&o;export{e as _};
//# sourceMappingURL=_freeGlobal.js.map
